var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashIconBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09088 2.18178L1.09088 10.9091L2.18179 10.9091L2.18179 2.18178L1.09088 2.18178Z",
    fill: "#272527"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81819 2.18176L2.18182 2.18176V3.27267L9.81819 3.27267V2.18176Z",
    fill: "#272527"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.43055e-07 -2.21729e-05L0 3.27271L1.09091 3.27271L1.09091 -2.22206e-05L-1.43055e-07 -2.21729e-05Z",
    fill: "#272527"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 -2.21729e-05L10.9091 3.27271L12 3.27271L12 -2.22206e-05L10.9091 -2.21729e-05Z",
    fill: "#272527"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.09094 1.09094L10.9091 1.09094L10.9091 3.24249e-05L1.09094 3.32833e-05L1.09094 1.09094Z",
    fill: "#272527"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81819 10.9091H2.18182V12H9.81819V10.9091Z",
    fill: "#272527"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81818 2.18178L9.81818 10.9091L10.9091 10.9091L10.9091 2.18178L9.81818 2.18178Z",
    fill: "#272527"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27271 4.36369L3.27271 9.81824L4.36361 9.81824L4.36361 4.36369L3.27271 4.36369Z",
    fill: "#272527"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45453 4.36369L5.45453 9.81824L6.54544 9.81824L6.54544 4.36369L5.45453 4.36369Z",
    fill: "#272527"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63635 4.36369L7.63635 9.81824L8.72726 9.81824L8.72726 4.36369L7.63635 4.36369Z",
    fill: "#272527"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconBlack);
export default __webpack_public_path__ + "static/media/Trash-Icon-Black.746f725d49b7ed3857d4614c514d4fc0.svg";
export { ForwardRef as ReactComponent };